import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  MarkIndirectPurchaseOrderAsSentInput,
  MarkIndirectPurchaseOrderAsSentMutation,
} from '@/gql/graphql';

const MarkIndirectPurchaseOrderAsSent = graphql(`
  mutation MarkIndirectPurchaseOrderAsSent(
    $input: MarkIndirectPurchaseOrderAsSentInput!
  ) {
    markIndirectPurchaseOrderAsSent(input: $input) {
      __typename
      ... on MarkIndirectPurchaseOrderAsSentSuccess {
        purchaseOrder {
          id
        }
      }
      ... on MarkIndirectPurchaseOrderAsSentError {
        message
      }
    }
  }
`);

const useMarkIndirectPurchaseOrderAsSent = (
  options?: UseMutationOptions<
    MarkIndirectPurchaseOrderAsSentMutation,
    unknown,
    MarkIndirectPurchaseOrderAsSentInput
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(MarkIndirectPurchaseOrderAsSent, { input });
    },
    ...options,
  });
};

export default useMarkIndirectPurchaseOrderAsSent;
